import { CategoriesContainer } from '@/modules/Categories';

export const Categories = (): JSX.Element => <CategoriesContainer />;

export default Categories;
